import DataTable from "@/components/admin/DataTable";
import { adminApi } from "@/lib/adminApi";

const columns = [
  { key: "created_at", label: "Inscrit le", format: "date" },
  { key: "prenom", label: "Prénom" },
  { key: "email", label: "Email" },
];

export default function NotificationsList() {
  return (
    <DataTable
      testId="admin-notifications"
      title="Liste « Être informé »"
      subtitle="Personnes à prévenir lors de l'ouverture de nouvelles dates d'ateliers."
      fetcher={adminApi.listNotifications}
      columns={columns}
    />
  );
}
